<template>
  <div class="loader">
    <div class="dot-parent">
      <div class="dot one" />
      <div class="dot two" />
      <div class="dot three" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.loader {
  display: grid;
  place-items: center;
  height: 200px;
}
.dot-parent {
  display: flex;
  justify-content: space-evenly;
  width: min-content;
}
.dot {
  border-radius: 50%;
  width: 12px;
  margin: 0 10px;
  height: 12px;
  background: #ffdf22;
  margin: 0 10px;
  transform: scale(0);
  animation: dots 1.4s infinite ease-in;
}

.two {
  animation-delay: 0.4s;
}
.three {
  animation-delay: 0.8s;
}
@keyframes dots {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  80% {
    transform: scale(0.7);
  }
  100% {
    transform: scale(0);
  }
}
</style>
